import Agendamento from "@/views/agendamento.vue";
import Convenios from "@/views/convenio.vue";
import Especialidades from "@/views/especialidade.vue";
import Clinicas from "@/views/clinica.vue";
import Agendas from "@/views/agendar.vue";
import Pacientes from "@/views/pacientes.vue";
import Profissionais from "@/views/profissionais.vue";
import Confirmacao from "@/views/confirmacao.vue";
import onBeforeEnter from "@/core/routerHelper";
import Store from "@/store.js";

export default [
  {
    path: "/consulta/:organizationId",
    name: "consulta",
    component: Agendamento,
    children: [
      {
        path: "convenio",
        name: "consulta_convenio",
        component: Convenios,
        beforeEnter: onBeforeEnter(1)
      },
      {
        path: "especialidade",
        name: "consulta_especialidade",
        component: Especialidades,
        beforeEnter: onBeforeEnter(2)
      },
      {
        path: "clinica",
        name: "consulta_clinica",
        component: Clinicas,
        beforeEnter: onBeforeEnter(3)
      },
      {
        path: "agendar",
        name: "consulta_agendar",
        component: Agendas,
        beforeEnter: onBeforeEnter(4)
      },
      {
        path: "profissional",
        name: "consulta_profissional",
        component: Profissionais,
        beforeEnter: onBeforeEnter(5)
      },
      {
        path: "paciente",
        name: "consulta_paciente",
        component: Pacientes,
        beforeEnter: (to, from, next) => {
          if (!Store.getters.token) {
            Store.dispatch("set_to", to);
            Store.dispatch("set_modalLogin", true);
          } else if(Store.getters.token) {
            Store.commit("set_actualstep", 6);
            next();
          }


        }
      },
      {
        path: "confirmacao",
        name: "consulta_confirmacao",
        component: Confirmacao,
        beforeEnter: (to, from, next) => {
          if (Store.getters.token === "") {
            Store.dispatch("set_to", to);
            Store.dispatch("set_modalLogin", true);
          }

          if (!Store.state.Appointment.selected.every(it => it.nome)) {
            next({
              name: "convenio",
              params: { organizationId: to.params.organizationId },
              query: to.query
            });
          }

          Store.commit("set_actualstep", 7);
          next();
        }
      }
    ]
  }
];
